import { forwardRef, Module } from '@nestjs/common';
import { PostService } from './post.service';
import { PostController } from './post.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PostEntity } from './post.entity';
import { PostFilesModule } from '../post-files/post-files.module';
import { PollModule } from '../poll/poll.module';
import { ProfileModule } from '../profile/profile.module';
import { PostActivityModule } from '../post-activity/post-activity.module';
import { CommentsModule } from '../comments/comments.module';
import { PollVotingEntity } from '../poll/poll-voting.entity';
import { HierarchyEntity } from '../hierarchy/hierarchy.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([PostEntity,PollVotingEntity,HierarchyEntity]),
    forwardRef(() =>PostFilesModule), forwardRef(()=>PollModule), forwardRef(() =>ProfileModule),
    forwardRef(()=>PostActivityModule), forwardRef(() => CommentsModule)
  ],
  providers: [PostService],
  controllers: [PostController],
  exports:[PostService]
})
export class PostModule {}
